import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { DocQueueModel } from '@smarttask-common/src/lib/models/Record/Doc/Queue/DocQueueModel';

export enum DocQueueActionTypes {
    ADD_QUEUE = '[DocQueue] Create DocQueue',
    ADD_QUEUES = '[DocQueue] Add DocQueues',
    UPSERT_QUEUE = '[DocQueue] Upsert DocQueue',
    UPSERT_QUEUES = '[DocQueue] Upsert DocQueues',
    UPDATE_QUEUE = '[DocQueue] Update DocQueue',
    UPDATE_QUEUES = '[DocQueue] Update DocQueues',
    DELETE_QUEUE = '[DocQueue] Delete DocQueue',
    DELETE_QUEUES = '[DocQueue] Delete DocQueues',
    DELETE_ALL_QUEUES = '[DocQueue] Delete All DocQueues',
    DELETE_ALL = '[DocQueue] Delete All',

    UPDATE_SELECTED_ID = '[DocQueue] Update SelectedId',
}

export class UpdateSelectedDocQueueId implements Action {
    readonly type = DocQueueActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_id: string) {}
}

export class AddOne implements Action {
    readonly type = DocQueueActionTypes.ADD_QUEUE;
    constructor(public queue_item: DocQueueModel) {}
}

export class AddMany implements Action {
    readonly type = DocQueueActionTypes.ADD_QUEUES;
    constructor(public queue: Array<DocQueueModel>) {}
}

export class UpsertOne implements Action {
    readonly type = DocQueueActionTypes.UPSERT_QUEUE;

    constructor(public queue_item: DocQueueModel) {}
}

export class UpsertMany implements Action {
    readonly type = DocQueueActionTypes.UPSERT_QUEUES;
    constructor(public queue: Array<DocQueueModel>) {}
}

export class UpdateOne implements Action {
    readonly type = DocQueueActionTypes.UPDATE_QUEUE;
    constructor(public queue_item: Update<DocQueueModel>) {}
}

export class UpdateMany implements Action {
    readonly type = DocQueueActionTypes.UPDATE_QUEUES;
    constructor(public queue: Array<Update<DocQueueModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = DocQueueActionTypes.DELETE_QUEUE;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = DocQueueActionTypes.DELETE_QUEUES;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = DocQueueActionTypes.DELETE_ALL_QUEUES;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = DocQueueActionTypes.DELETE_ALL;
    constructor() {}
}

export type DocQueueActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedDocQueueId;
